import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, Typography, Card, CardContent } from '@mui/material';
import RatePlanFormComponent from '@/components/rateplans/RatePlanForm';
var RatePlanForm = function () {
    var id = useParams().id;
    var isEdit = !!id;
    return (_jsxs(Box, { p: 3, children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, children: isEdit ? 'Editar Rate Plan' : 'Nuevo Rate Plan' }), _jsx(Card, { children: _jsx(CardContent, { children: _jsx(RatePlanFormComponent, { ratePlanId: id }) }) })] }));
};
export default RatePlanForm;
